module.exports = "/_next/static/images/feature1-d6868237f42bb98d1edd7371d5e0ce87.png";